@let etape = etapeSelectionnee();
<div class="gap-lg grid">
  <p class="pt-lg text-content-secondary">
    Sélectionnez les {{ traductions().livrable + 's' }} que vous souhaitez utiliser dans votre module. Un
    {{ traductions().livrable }} minimum.
  </p>
  @if (etape) {
    <div
      class="p-md hover:bg-components-background-neutral-lighter group/item gap-xxs flex items-center justify-between hover:cursor-pointer hover:rounded-b-md"
      (click)="toggleCheckbox()"
    >
      <div class="flex w-full">
        <hlm-checkbox [checked]="isLivrableGeneriqueChecked()" [disabled]="!peutModifier()" />
        <div class="space-between flex w-full">
          <div class="ml-xs flex w-full flex-col">
            <span class="component-medium-medium capitalize"> {{ traductions().livrable }} "Générique" </span>
            <span class="text-content-secondary component-small-medium">
              <span class="capitalize">{{ traductions().livrable }}</span> générique à caractériser
            </span>
          </div>
          @if (peutModifier()) {
            <button
              [class]="{ invisible: !isLivrableGeneriqueChecked() }"
              (click)="ouvreSousCaracteristiques(); $event.stopPropagation()"
              hlmBtn
              size="icon"
              variant="ghost"
              hlmTooltipTrigger="Définir les sous-caractéristiques"
            >
              <ng-icon hlm size="sm" name="lucideSettings2" />
            </button>
          }
        </div>
      </div>
    </div>
    @for (famille of etape.famillesLivrables | trierPar: 'nom'; track famille.id) {
      <app-expansion-panel [titre]="famille.nom" [item]="famille" [isOpen]="true">
        <div class="flex flex-col">
          @for (
            livrable of famille.livrables | trierPar: 'nom';
            track livrable.id;
            let idx = $index;
            let last = $last
          ) {
            <app-checkbox-submenu-item [item]="livrable" [formcontrol]="livrables">
              <div class="flex" [class]="{ invisible: !isSelected(livrable) }">
                <app-chip [label]="countCaracteristique(livrable)" hlmTooltipTrigger="Caractéristiques sélectionnées" />
                <button
                  (click)="ouvreSousCaracteristiques(livrable); $event.stopPropagation()"
                  hlmBtn
                  size="icon"
                  variant="ghost"
                  hlmTooltipTrigger="Définir les sous-caractéristiques"
                >
                  <ng-icon hlm size="sm" name="lucideSettings2" />
                </button>
              </div>
            </app-checkbox-submenu-item>

            @if (!last) {
              <div hlmItemSeparator></div>
            }
          } @empty {
            <span class="py-md px-lg text-content-secondary paragraph-medium-medium"
              >Pas de {{ traductions().livrable }} associé à cette famille dans ce module.</span
            >
          }
        </div>
      </app-expansion-panel>
    }
  }
</div>
